import moment from "moment";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Navbar from "../../components/Navbar";
import { useGetAssignmentsQuery } from "../../features/assignments/assignmentApi";
import { toggleModal } from "../../features/assignments/assignmentSlice";
import { useGetVideosQuery } from "../../features/videos/videoApi";
import { seletedVideo } from "../../features/videos/videoSlice";
import Assignment from "./Assignment";

const CoursePlayer = () => {
  const { selectedVideo } = useSelector((state) => state.videos);
  const dispatch = useDispatch();
  console.log(
    "🚀 ~ file: CoursePlayer.js:9 ~ CoursePlayer ~ selectedVideo:",
    selectedVideo
  );
  const { data: videos, isLoading } = useGetVideosQuery();
  const { data: assignments } = useGetAssignmentsQuery()
  console.log("🚀 ~ file: CoursePlayer.js:7 ~ CoursePlayer ~ data:", videos);

  useEffect(() => {
    if (videos) {
      dispatch(seletedVideo(videos[0]));
    }
  }, [videos]);

  const handleVideo = (video) => {
    dispatch(seletedVideo(video));
  };

  if (isLoading || !selectedVideo) {
    return <div>Loading...</div>;
  }

  // useE
  return (
    <>
      <Navbar />
      <section className="py-6 bg-primary">
        <div className="mx-auto max-w-7xl px-5 lg:px-0">
          <div className="grid grid-cols-3 gap-2 lg:gap-8">
            <div className="col-span-full w-full space-y-8 lg:col-span-2">
              <iframe
                width="100%"
                className="aspect-video"
                src={selectedVideo.url}
                title="Things I wish I knew as a Junior Web Developer - Sumit Saha - BASIS SoftExpo 2023"
                frameBorder={0}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
              <div>
                <h1 className="text-lg font-semibold tracking-tight text-slate-100">
                  {selectedVideo.title}
                </h1>
                <h2 className=" pb-4 text-sm leading-[1.7142857] text-slate-400">
                  Uploaded on
                  {moment(selectedVideo.createdAt).format("DD MMMM YYYY")}
                </h2>
                <div className="flex gap-4">
                  
                  <button
                    onClick={() => dispatch(toggleModal(true))}
                    className="px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm hover:bg-cyan hover:text-primary"
                  >
                    এসাইনমেন্ট
                  </button>
                  <Link
                    to={`/student/quiz/${selectedVideo.id}`}
                    className="px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm hover:bg-cyan hover:text-primary"
                  >
                    কুইজে অংশগ্রহণ করুন
                  </Link>
                </div>
                <p className="mt-4 text-sm text-slate-400 leading-6">
                  {selectedVideo.description}
                </p>
              </div>
            </div>
            <div className="col-span-full lg:col-auto max-h-[570px] overflow-y-auto bg-secondary p-4 rounded-md border border-slate-50/10 divide-y divide-slate-600/30">
              {videos?.map((video) => (
                <div
                  className="w-full flex flex-row gap-2 cursor-pointer hover:bg-slate-900 p-2 py-3"
                  onClick={() => handleVideo(video)}
                >
                  {/* Thumbnail */}
                  <svg
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15.91 11.672a.375.375 0 010 .656l-5.603 3.113a.375.375 0 01-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112z"
                    />
                  </svg>
                  {/* Description */}
                  <div clas="flex flex-col w-full">
                    <p className="text-slate-50 text-sm font-medium">
                      {video.title}
                    </p>
                    <div>
                      <span className="text-gray-400 text-xs mt-1">
                        {video.duration} Mins
                      </span>
                      <span className="text-gray-400 text-xs mt-1"> | </span>
                      <span className="text-gray-400 text-xs mt-1">
                        {video.views} views
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <Assignment />
    </>
  );
};

export default CoursePlayer;
